import { call, put } from "redux-saga/effects";
import api from "../../services/api";
import { Creators as DesempenhoActions } from "../ducks/desempenho";
import { Creators as ErrorActions } from "../ducks/error";
import { Creators as LoadingActions } from "../ducks/loading";

export function* getListDesempenho({ payload }) {
  try {
    yield put(LoadingActions.setLoading());
    const data = yield call(api.post, `/reports/performance`, payload.filtro);
    if (data.data.length > 0) {
      yield put(DesempenhoActions.getListDesempenhoSuccess(data.data));
    } else {
      yield put(
        ErrorActions.openError(
          "Os filtros escolhidos não obtiveram resultados."
        )
      );
    }
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}



// WEBPACK FOOTER //
// ./src/store/sagas/desempenho.js